import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {

export class RainbowMagicClassic_1Screen extends SlotGameType1_1Screen {



    protected override helpFactory: IHelpFactory = new RainbowMagicClassicHelpFactory();
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "yellow",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }
    //LED COLOR
    protected override ColorLed: string = "255,255,0\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RainbowMagicClassic");

        this.spinnableReelsParams.topBorderWidth = 7;
        this.spinnableReelsParams.bottomBorderWidth = 7;
    }

    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg,  rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

}

//Help Colorized
class RainbowMagicClassicHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new RainbowMagicClassicHelp(params);
    }
}

class RainbowMagicClassicHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

// }
